import {
  OscPreChatHeaderProps,
  wiseOwlOneAdminCopy,
  wiseOwlViewCopy,
  wiseOwlZendeskCopy,
  wiseOwlSalesforceCopy,
  wiseOwlVoiceInsightsCopy,
} from "@twiliointernal/e2-commons-shared-definitions";

export const oscPreChatConfiguration = (
  name?: string
): OscPreChatHeaderProps => ({
  headerText: wiseOwlViewCopy.preChat.headerText(name),
  secondaryHeaderText: "",
  subText: wiseOwlViewCopy.preChat.subText,
  anchorProps: {
    children: wiseOwlViewCopy.preChat.anchorText,
    // link to quick start guide
    href: "https://help.twilio.com/articles/18133722687643",
    showExternal: true,
  },
});

export const sghcPreChatConfiguration: OscPreChatHeaderProps = {
  headerText: wiseOwlViewCopy.preChat.headerText(),
  secondaryHeaderText: wiseOwlViewCopy.preChat.secondaryHeaderText,
  subText: wiseOwlViewCopy.preChat.subText,
  anchorProps: {
    children: wiseOwlViewCopy.preChat.anchorText,
    // link to quick start guide
    href: "https://support.sendgrid.com/hc/en-us/articles/11921855923611-Contacting-Twilio-SendGrid-Support",
    showExternal: true,
  },
};

export const wozdPreChatConfiguration = (
  name?: string
): OscPreChatHeaderProps => ({
  hasImage: false,
  headerText: wiseOwlZendeskCopy.preChat.headerText(name),
  secondaryHeaderText: wiseOwlZendeskCopy.preChat.secondaryHeaderText,
  anchorProps: {
    children: wiseOwlZendeskCopy.preChat.anchorText,
    // link to quick start guide
    href: "https://switchboard.twilio.com/sites/customer-support/resource/45393/process-wise-owl-in-zendesk",
    showExternal: true,
  },
});

export const wiseOwlAppPreChatConfiguration = (
  name?: string
): OscPreChatHeaderProps => ({
  hasImage: true,
  headerText: wiseOwlSalesforceCopy.preChat.headerText(name),
  secondaryHeaderText: wiseOwlSalesforceCopy.preChat.secondaryHeaderText,
  subText: wiseOwlViewCopy.preChat.subText,
  anchorProps: {
    children: wiseOwlViewCopy.preChat.anchorText,
    // link to quick start guide
    href: "https://docs.google.com/document/d/1eB1MNzSSM9xbEaE4AjoHlnI7DBOM6AnjBsH3kG_k6q8",
    showExternal: true,
  },
});

export const consolePreChatConfiguration = (displayName: string) => ({
  headerText: wiseOwlVoiceInsightsCopy.preChat.headerText,
  secondaryHeaderText:
    wiseOwlVoiceInsightsCopy.preChat.secondaryHeaderText(displayName),
  subText: wiseOwlVoiceInsightsCopy.preChat.subText,
  anchorProps: {
    children: wiseOwlVoiceInsightsCopy.preChat.anchorText,
    // link to quick start guide
    href: "https://help.twilio.com/articles/18133722687643",
    showExternal: true,
  },
});

export const oneAdminPreChatConfiguration: OscPreChatHeaderProps = {
  hasImage: true,
  headerText: wiseOwlOneAdminCopy.preChat.headerText,
};
